import { SearchQueryOrderDirection } from "types/generated";

export const INITIAL_SORT_OPTION = "name";
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;
export const FILTER_TYPE = "spacelift-vcs-repos";

export const SPACELIFT_VCS_REPOS_SUGGESTIONS_DICTIONARY: Record<string, string> = {};
